import React, { useEffect } from 'react';
import { Button } from 'antd';
import cx from 'classnames';
import { gettext } from '@cranium/i18n';
import { i18n } from '@/core';
import styled from 'styled-components';
import { useHistory } from '@/shared/navigation';
import { Title, Register } from './component';
import { LoginLayout } from '@pages/Login/LoginLayout';

const SUPPORTED_IDENTITY_TYPES = (process.env.REACT_APP_SUPPORTED_IDENTITY_TYPES || '').split(',');

const identityToButtonMapping = {
  partner: {
    icon: 'pe-7s-network',
    color: '#6cc3d5',
    label: gettext('Partner')
  },
  supplier: {
    icon: 'pe-7s-map-2',
    color: '#1fb841',
    label: gettext('Supplier')
  }
};

const options = Object.entries(identityToButtonMapping)
  .filter(([key]) => SUPPORTED_IDENTITY_TYPES.includes(key))
  .map(([type, value]) => ({
    value: type,
    props: value
  }));

const WarningMessage = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #f41d39;
`;

export const SelectType: React.FC = () => {
  const history = useHistory();
  useEffect(() => {
    if (options.length === 1) {
      history.push(`/login/${options[0].value}`);
    }
  }, []);
  if (options.length === 0) {
    return (
      <WarningMessage>
        {i18n.t('forms.login.sorryForInconvenience')}
        <br />
        {i18n.t('forms.login.authUnavailable')}
      </WarningMessage>
    );
  }

  return (
    <LoginLayout>
      <div>
        <Title>{gettext('Login as')}</Title>
        <Row>
          {options.map(identityOption => {
            return (
              <StyledButton
                data-testid={`button-${identityOption.value}`}
                key={identityOption.value}
                className={'btn-icon-vertical'}
                color={identityOption.props.color}
                onClick={() => {
                  history.push(`/login/${identityOption.value}`);
                }}
              >
                <i className={cx('btn-icon-wrapper', identityOption.props.icon)} />
                {identityOption.props.label}
              </StyledButton>
            );
          })}
        </Row>
        <Register />
      </div>
    </LoginLayout>
  );
};

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
`;

const StyledButton = styled(Button)<{ color?: string }>`
  background-color: ${({ color }) => color} !important;
  border-color: ${({ color }) => color} !important;
  padding: 16px 12px !important;
  height: auto !important;
  color: var(--white) !important;
  font: var(--font-regular-14) !important;
`;
